<template>
	<div class="doku-custom">
		<form action="" method="POST" id="payment-form">
			<div doku-div='form-payment'>
			<input id="doku-token" name="doku-token" type="hidden" />
			<input id="doku-pairing-code" name="doku-pairing-code" type="hidden" />
			</div>
		</form>
	</div>
</template>
<script>
	import {mapGetters} from 'vuex'
	export default{
		data(){
			return{
				
			}
		},
		created(){
			this.FillData()
			var element = document.createElement("link");
		    element.setAttribute("rel", "stylesheet");
		    element.setAttribute("type", "text/css");
		    element.setAttribute("title", "doku");
		    element.setAttribute("href", "https://staging.doku.com/doku-js/assets/css/doku.css");
		    document.getElementsByTagName("head")[0].appendChild(element);
		},
		destroyed(){
			    var element = document.querySelector("link[title='doku']")
    			element.parentNode.removeChild(element);
    			// document.querySelector("link[title='doku']").getAttribute("href");
		},
		methods:{
			...mapGetters(['getTicketPayment']),
			FillData(){
				var data = new Object();
				data.req_merchant_code = this.getTicketPayment().data.form.req_mall_id;
				data.req_chain_merchant = this.getTicketPayment().data.form.req_chain_merchant;
				data.req_payment_channel = this.getTicketPayment().data.form.req_payment_channel; // ‘15’ =  credit card
				data.req_transaction_id = this.getTicketPayment().data.form.req_trans_id_merchant ;
				data.req_currency = this.getTicketPayment().data.form.req_currency;
				data.req_amount = this.getTicketPayment().data.form.req_amount ;
				data.req_words = this.getTicketPayment().data.form.req_words ;
				data.req_session_id = this.getTicketPayment().data.form.req_session_id ;
				data.req_form_type = this.getTicketPayment().data.form.req_form_type ;
				data.req_customer_id = this.getTicketPayment().data.form.req_customer_id ;
				data.req_token_payment = this.getTicketPayment().data.form.req_token_payment; 
				data.req_server_url = this.getTicketPayment().data.req_server_url ;
				getForm(data, 'staging'); //for production environment, change ‘staging’ to ‘production’
			}
		}
	}
</script>
<!-- <style scoped lang="less">
		.doku-custom ::v-deep form{
			@import 'https://staging.doku.com/doku-js/assets/css/doku.css';
		}
</style> -->
<style scoped>
	@import 'https://cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.css'
</style>
<style>
	.default-width{
		width: auto !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/ticket/DokuForm.vue